module.exports = __webpack_public_path__ + "img/icon_ymx.3ef4fa93.png";